import apiConfig from "../../utils/config.json";
import httpService from "../httpService";

const apiEndPoint = `${apiConfig.apiUrl}centerInCharge/get/allStudents`;
const apiEndPointForTodayStudents = `${apiConfig.apiUrl}centerInCharge/get/todayStudents`;
const apiEndPointForTodayAllStudents = `${apiConfig.apiUrl}centerInCharge/get/todayAllStudents`;
const apiEndPointUpdateStudent = `${apiConfig.apiUrl}centerInCharge/update/student`;
const apiEndPointUpdateAttendance = `${apiConfig.apiUrl}centerInCharge/update/student/attendanceOut`;

export function getCenterAllStudents(centerId, value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {}
  };
  return httpService.post(`${apiEndPoint}/${centerId}`, obj);
}

export function getCenterTodayStudents(centerId, value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {}
  };
  return httpService.post(`${apiEndPointForTodayStudents}/${centerId}`, obj);
}

export function getCenterTodayAllStudents(centerId) {
  return httpService.get(`${apiEndPointForTodayAllStudents}/${centerId}`);
}

export function updateRegisteredStudent(studentCode, student) {
  const obj = {
    studentCode: studentCode,
    studentName: student.studentName,
    email: student.email,
    phoneNumber: student.phoneNumber,
    parentPhoneNumber: student.parentPhoneNumber,
    address: student.address,
  };
  return httpService.put(apiEndPointUpdateStudent, obj);
}
export function updateStudentAttendance(studentAttendanceCode) {
  console.log(studentAttendanceCode);
  const obj = {
    attendanceCode: studentAttendanceCode,
  };
  return httpService.put(apiEndPointUpdateAttendance, obj);
}
export default {
  getCenterAllStudents,
  getCenterTodayStudents,
  getCenterTodayAllStudents,
  updateStudentAttendance,
};
